import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import { apply, compose, either, find, getPath, identity, pipe, propEquals } from '@anewgo/functions';
var arrayify = apply(function (context) {
  return [context];
});
export var readonlySalesStatuses = ['CLOSED', 'MODEL', 'RESERVED', 'SOLD', 'UNDER_CONTRACT'];
export var inventoryRequiredSalesStatuses = ['FUTURE_INVENTORY', 'INVENTORY', 'UNDER_CONSTRUCTION'];
export var inventoryExemptedSalesStatuses = ['AVAILABLE'];
export var isInventoryLot = function isInventoryLot(lot) {
  return lot.inventory && inventoryRequiredSalesStatuses.includes(lot.salesStatus);
};
export var availablePlansForLot = function availablePlansForLot(lot, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      plans = _ref.plans;

  if (!inventoryExemptedSalesStatuses.includes(lot.salesStatus) && getPath('inventory', 'plan')(lot)) {
    return [lot.inventory.plan];
  }

  if (lot.availablePlanElevations !== undefined) {
    return plans.filter(function (plan) {
      return lot.availablePlanElevations.some(propEquals('planId', plan.id));
    });
  } else if (lot.excludedPlanElevations !== undefined) {
    var availablePlans = [];
    plans.forEach(function (plan) {
      var planInUse = plan.elevations.some(function (elevation) {
        return !lot.excludedPlanElevations.some(function (excludedPlanElev) {
          return excludedPlanElev.planId === plan.id && excludedPlanElev.elevationId === elevation.id;
        });
      });
      if (planInUse) availablePlans.push(plan);
    });
    return availablePlans;
  }

  return [];
};
export var availableElevationsForLot = function availableElevationsForLot(lot, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
      plans = _ref2.plans;

  if (!inventoryExemptedSalesStatuses.includes(lot.salesStatus) && getPath('inventory', 'elevation')(lot)) {
    return [lot.inventory.elevation];
  }

  if (lot.availablePlanElevations !== undefined) {
    return lot.availablePlanElevations.map(function (_ref3) {
      var planId = _ref3.planId,
          elevationId = _ref3.elevationId;
      return pipe(find(propEquals('id', planId)), getPath('elevations'), apply(find(propEquals('id', elevationId))))(plans);
    }).filter(identity);
  } else if (lot.excludedPlanElevations !== undefined) {
    return calculateAvailablePlansElevationFromExcluded(plans, lot.excludedPlanElevations, true);
  }

  return [];
};
export var availablePlanElevationsForLot = function availablePlanElevationsForLot(lot, plans) {
  if (lot.inventory && lot.inventory.planId && lot.inventory.elevationId) {
    return [{
      planId: lot.inventory.planId,
      elevationId: lot.inventory.elevationId
    }];
  }

  if (lot.availablePlanElevations !== undefined) {
    return lot.availablePlanElevations || [];
  } else if (plans && lot.excludedPlanElevations !== undefined) {
    return calculateAvailablePlansElevationFromExcluded(plans, lot.excludedPlanElevations);
  }

  return [];
};

var calculateAvailablePlansElevationFromExcluded = function calculateAvailablePlansElevationFromExcluded(plans, excludedPlanElevations, returnFullElevation) {
  var availablePlanElevations = [];
  plans.forEach(function (plan) {
    plan.elevations.forEach(function (elevation) {
      if (!excludedPlanElevations.some(function (excludedPlanElev) {
        return excludedPlanElev.planId === plan.id && excludedPlanElev.elevationId === elevation.id;
      })) {
        if (returnFullElevation) {
          availablePlanElevations.push(elevation);
        } else {
          availablePlanElevations.push({
            planId: plan.id,
            elevationId: elevation.id
          });
        }
      }
    });
  });
  return availablePlanElevations;
};

export var availableSchemesForLot = either(compose(arrayify, getPath('inventory', 'exteriorConfiguration', 'scheme')), getPath('availableSchemes'));